package org.vreo.devicehub.features.core.data.device.dto

import kotlinx.serialization.Serializable

/**
 * Anpr device details response Dto
 *
 * @property id device id.
 * @property productNumber device product number.
 * @property serialNumber device serial number.
 * @property softwareVersion device software version.
 * @property ocrVersion device ocr version.
 * @property localIpAddress device local network ip address.
 * @property macAddress device MAC address
 * @property connectionStatus device connection to network status.
 * @property lastActivityTime device last activity time.
 * @property userTag device owner tag, allows user to add name/tag to device
 * @property linkingKey device access password
 * @property primaryConnectionKey device connection string, allows device to connect to IoT provider.
 */
@Serializable
data class AnprDetailsResponseDto(
    val id: String,
    val productNumber: String,
    val serialNumber: String,
    val softwareVersion: String?,
    val ocrVersion: String?,
    val localIpAddress: String? = null,
    val macAddress: String? = null,
    val connectionStatus: Boolean,
    val lastActivityTime: Long?,
    val userTag: String? = null,
    val linkingKey: String? = null,
    val primaryConnectionKey: String? = null
)
